import React from "react";

const BS5_Dropdowns = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Dropdowns Component</h2>
      <p>This is the BS5_Dropdowns component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Dropdowns;
